import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { VerifyEmailPage } from '../pages/VerifyEmailPage'

export function RequireAuth() {
  const { user, loading } = useAuth()
  if (loading) {
    return (
      <div className="shell">
        <p className="muted">Checking session…</p>
      </div>
    )
  }
  if (!user) return <Navigate to="/login" replace />
  // Email-link sign-in verifies email; this guards stale sessions / future providers.
  if (!user.emailVerified) return <VerifyEmailPage />
  return <Outlet />
}
